import { pluralToSingular } from '@/src/utils/generalUtil'
export default {
  sectionName: (state) => state.routerList.SECTIONS.DISPLAY_NAME,
  className: (state) => state.routerList.CLASSES.DISPLAY_NAME,
  sectionNameSingular: (state, getters) => pluralToSingular(getters.sectionName),
  classNameSingular: (state, getters) => pluralToSingular(getters.className),
}
